import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStore, Console, SsoService } from '@core/services';
import { take } from 'rxjs/operators';

/**
 * Pagina SSO veloce: intercetta il flusso di generazione ticket e mostra solo
 * uno spinner durante il redirect. Le app client possono usare /sso-fast?target_app=xxx
 * per un'esperienza più snella rispetto alla root con target_app.
 * Per `app-portale` il profilo si legge da `GET portale-agenzia/me`.
 */
@Component({
  selector: 'app-sso-fast',
  templateUrl: './sso-fast.html',
  styleUrl: './sso-fast.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SsoFast implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly appStore = inject(AppStore);
  private readonly ssoService = inject(SsoService);

  ngOnInit(): void {
    const targetApp = (
      this.activatedRoute.snapshot.queryParams['target_app'] as string | undefined
    )?.trim();

    if (!targetApp) {
      this.router.navigate(['/login']);
      return;
    }

    if (this.appStore.isAuthenticated()) {
      this.ssoService
        .generateTicketAndRedirect(targetApp, {
          fallbackUrl: '/login',
          preserveTargetAppOnError: true,
          openInNewTab: false
        })
        .pipe(take(1))
        .subscribe({
          error: (error) => {
            Console.error('SsoFast', { message: 'Errore nel flusso SSO', error });
          }
        });
    } else {
      this.router.navigate(['/login'], {
        queryParams: { target_app: targetApp }
      });
    }
  }
}
